import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import localeUtils from 'utils/datePickerTranslation';

const isSameDay = (a, b) => a.isSame(b, 'day');

const DatePicker = createClass({
  propTypes: {
    selectedDate: PropTypes.object,
    secondaryDate: PropTypes.object,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    onChange: PropTypes.func
  },

  componentWillReceiveProps(nextProps) {
    this.refs.datePicker.showMonth(moment(nextProps.selectedDate).toDate());
  },

  onDaySelect(day, modifiers, evt) {
    if (modifiers.disabled) return;
    if (this.props.onChange) this.props.onChange(day);
  },

  render() {
    var today = moment();

    var selectedDate = this.props.selectedDate ? moment(this.props.selectedDate) : today;
    var secondaryDate = this.props.secondaryDate && moment(this.props.secondaryDate);
    var minDate = this.props.minDate && moment(this.props.minDate);
    var maxDate = this.props.maxDate && moment(this.props.maxDate);

    var range = selectedDate && secondaryDate && moment().range(selectedDate, secondaryDate);

    var modifiers = {
      disabled: (originDay) => {
        var day = moment(originDay);
        if (maxDate && day.diff(maxDate) > 0) return true;
        if (minDate && day.diff(minDate) < 0) return true;
        return false;
      },
      selected: (originDay) => {
        var day = moment(originDay);
        return isSameDay(selectedDate, day);
      },
      today: (originDay) => {
        var day = moment(originDay);
        return isSameDay(today, day);
      },
      secondarySelected: (originDay) => {
        var day = moment(originDay);
        return secondaryDate && isSameDay(secondaryDate, day);
      }
    };

    return (
      <DayPicker
        ref='datePicker'
        initialMonth={selectedDate.toDate()}
        className='DayPickerContainer'
        onDayClick={this.onDaySelect}
        modifiers={modifiers}
        enableOutsideDays
        localeUtils={localeUtils}
      />
    );
  }

});

export default DatePicker;
